import { SimpleAction } from './simple-action';

export class ToggleAction extends SimpleAction<any> {
  public isActive: boolean;
  public constructor(
    name: string,
    icon: string,
    text: string,
    isActive?: boolean,
    align?: 'left' | 'center' | 'right'
  ) {
    super(name, icon, null, text);
    this.isActive = isActive;
    this.category = 'toggle';
    this.showText = true;
    this.text = text;
    if (align) {
      this.align = align;
    }
  }

  /**
   * @deprecated
   * Use category property
   */
  override getActionType(): string {
    return 'toggle';
  }
}
